import AssignmentIcon from '@mui/icons-material/Assignment'
import BoltIcon from '@mui/icons-material/Bolt'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

// Single source of truth for ePCR record/form types. Future types (Cardiac
// Arrest, Primary Care, Critical Care) should be added here, mirrored in the
// server enum (models/patientRecords/EPCR.js) and given a form layout in
// EPCR.jsx.
export const EPCR_FORM_TYPES = [
  {
    value: 'ePCR',
    label: 'Full ePCR',
    headerTitle: null, // header shows patient details instead
    description:
      'The complete clinical record with all modules — assessment, vitals, treatment, safeguarding and sharing.',
    icon: AssignmentIcon,
    color: '#2F4F4F',
    bg: null,
  },
  {
    value: 'Fast Track',
    label: 'Fast Track',
    headerTitle: 'FAST TRACK RECORD',
    description:
      'A shortened clinical record for low-acuity presentations such as stings, grazes and minor bumps.',
    icon: BoltIcon,
    color: '#0D47A1',
    bg: '#E3F2FD',
  },
  {
    value: 'Welfare',
    label: 'Welfare',
    headerTitle: 'WELFARE RECORD',
    description:
      'A basic non-clinical record for lost or found children, safeguarding alerts passed from another organisation, lost or found property, and other welfare matters.',
    icon: VolunteerActivismIcon,
    color: '#4A148C',
    bg: '#F3E5F5',
  },
  {
    value: 'Critical Care',
    label: 'Critical Care',
    headerTitle: 'CRITICAL CARE RECORD',
    description:
      'HEMS and pre-hospital critical care. Tap-to-log live consoles for arrest, trauma, emergency anaesthesia and more, with the full ePCR to finish the detail afterwards.',
    icon: MonitorHeartIcon,
    color: '#B71C1C',
    bg: '#FFEBEE',
  },
]

// Record types that use the full tabbed ePCR layout (sidebar, Next buttons,
// review requirements, full complaint list…).
export const FULL_LAYOUT_MODES = ['ePCR', 'Critical Care']

export const isFullLayoutMode = (mode) =>
  FULL_LAYOUT_MODES.includes(mode ?? 'ePCR')

// Only Fast Track / Welfare force the incident type to 'Event'. Critical
// Care keeps it editable (HEMS jobs are primary / secondary responses).
export const FORCES_EVENT_INCIDENT = ['Fast Track', 'Welfare']

export const DEFAULT_ENABLED_RECORD_TYPES = ['ePCR', 'Fast Track', 'Welfare']

// Record types the tenant has switched on (Site Configuration -> Patient
// Records). undefined / empty = the original three; full ePCR is always on.
export const getEnabledRecordTypeValues = (orgSettings) => {
  const configured =
    orgSettings?.patientRecordSettings?.enabledRecordTypes ?? []
  const values = configured.length
    ? configured
    : DEFAULT_ENABLED_RECORD_TYPES
  return Array.from(new Set(['ePCR', ...values]))
}

export const getEnabledFormTypes = (orgSettings) => {
  const enabled = getEnabledRecordTypeValues(orgSettings)
  return EPCR_FORM_TYPES.filter((type) => enabled.includes(type.value))
}

export const getFormType = (mode) =>
  EPCR_FORM_TYPES.find((type) => type.value === mode) ?? EPCR_FORM_TYPES[0]
